import React from "react";
import LogoFid from "./shares/LogoFid";

const Forbiden = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" , height: "60vh"}}>
      <LogoFid largeur={300} />
      <h1>403 - Accès non autorisé</h1>
      <p>Vous n'etes pas autorisé à visiter le lien que vous avez saisie.</p>
    </div>
  );
};

export default Forbiden;
